/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientSurveyContactModel } from '../models/client-survey-contact-model';
import { createSurveyContactAsync$Json } from '../fn/survey-contact/create-survey-contact-async-json';
import { CreateSurveyContactAsync$Json$Params } from '../fn/survey-contact/create-survey-contact-async-json';
import { createSurveyContactAsync$Plain } from '../fn/survey-contact/create-survey-contact-async-plain';
import { CreateSurveyContactAsync$Plain$Params } from '../fn/survey-contact/create-survey-contact-async-plain';
import { getSurveyContactAsync$Json } from '../fn/survey-contact/get-survey-contact-async-json';
import { GetSurveyContactAsync$Json$Params } from '../fn/survey-contact/get-survey-contact-async-json';
import { getSurveyContactAsync$Plain } from '../fn/survey-contact/get-survey-contact-async-plain';
import { GetSurveyContactAsync$Plain$Params } from '../fn/survey-contact/get-survey-contact-async-plain';
import { getSurveyContactByIdAsync$Json } from '../fn/survey-contact/get-survey-contact-by-id-async-json';
import { GetSurveyContactByIdAsync$Json$Params } from '../fn/survey-contact/get-survey-contact-by-id-async-json';
import { getSurveyContactByIdAsync$Plain } from '../fn/survey-contact/get-survey-contact-by-id-async-plain';
import { GetSurveyContactByIdAsync$Plain$Params } from '../fn/survey-contact/get-survey-contact-by-id-async-plain';
import { updateSurveyContactAsync$Json } from '../fn/survey-contact/update-survey-contact-async-json';
import { UpdateSurveyContactAsync$Json$Params } from '../fn/survey-contact/update-survey-contact-async-json';
import { updateSurveyContactAsync$Plain } from '../fn/survey-contact/update-survey-contact-async-plain';
import { UpdateSurveyContactAsync$Plain$Params } from '../fn/survey-contact/update-survey-contact-async-plain';

@Injectable({ providedIn: 'root' })
export class SurveyContactService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSurveyContactAsync()` */
  static readonly GetSurveyContactAsyncPath = '/api/SurveyContact';

  /**
   * get surveycontact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyContactAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactAsync$Plain$Response(params: GetSurveyContactAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactModel>> {
    return getSurveyContactAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveycontact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyContactAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactAsync$Plain(params: GetSurveyContactAsync$Plain$Params, context?: HttpContext): Observable<ClientSurveyContactModel> {
    return this.getSurveyContactAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyContactModel>): ClientSurveyContactModel => r.body)
    );
  }

  /**
   * get surveycontact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyContactAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactAsync$Json$Response(params: GetSurveyContactAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactModel>> {
    return getSurveyContactAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveycontact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyContactAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactAsync$Json(params: GetSurveyContactAsync$Json$Params, context?: HttpContext): Observable<ClientSurveyContactModel> {
    return this.getSurveyContactAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyContactModel>): ClientSurveyContactModel => r.body)
    );
  }

  /** Path part for operation `createSurveyContactAsync()` */
  static readonly CreateSurveyContactAsyncPath = '/api/SurveyContact';

  /**
   * create surveycontact item.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurveyContactAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyContactAsync$Plain$Response(params?: CreateSurveyContactAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactModel>> {
    return createSurveyContactAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * create surveycontact item.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurveyContactAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyContactAsync$Plain(params?: CreateSurveyContactAsync$Plain$Params, context?: HttpContext): Observable<ClientSurveyContactModel> {
    return this.createSurveyContactAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyContactModel>): ClientSurveyContactModel => r.body)
    );
  }

  /**
   * create surveycontact item.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurveyContactAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyContactAsync$Json$Response(params?: CreateSurveyContactAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactModel>> {
    return createSurveyContactAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * create surveycontact item.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurveyContactAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyContactAsync$Json(params?: CreateSurveyContactAsync$Json$Params, context?: HttpContext): Observable<ClientSurveyContactModel> {
    return this.createSurveyContactAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyContactModel>): ClientSurveyContactModel => r.body)
    );
  }

  /** Path part for operation `getSurveyContactByIdAsync()` */
  static readonly GetSurveyContactByIdAsyncPath = '/api/SurveyContact/{surveyContactId}';

  /**
   * get surveycontact by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyContactByIdAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactByIdAsync$Plain$Response(params: GetSurveyContactByIdAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactModel>> {
    return getSurveyContactByIdAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveycontact by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyContactByIdAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactByIdAsync$Plain(params: GetSurveyContactByIdAsync$Plain$Params, context?: HttpContext): Observable<ClientSurveyContactModel> {
    return this.getSurveyContactByIdAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyContactModel>): ClientSurveyContactModel => r.body)
    );
  }

  /**
   * get surveycontact by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyContactByIdAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactByIdAsync$Json$Response(params: GetSurveyContactByIdAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactModel>> {
    return getSurveyContactByIdAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveycontact by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyContactByIdAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactByIdAsync$Json(params: GetSurveyContactByIdAsync$Json$Params, context?: HttpContext): Observable<ClientSurveyContactModel> {
    return this.getSurveyContactByIdAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyContactModel>): ClientSurveyContactModel => r.body)
    );
  }

  /** Path part for operation `updateSurveyContactAsync()` */
  static readonly UpdateSurveyContactAsyncPath = '/api/SurveyContact/{surveyContactId}';

  /**
   * update surveycontact by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSurveyContactAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyContactAsync$Plain$Response(params: UpdateSurveyContactAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactModel>> {
    return updateSurveyContactAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * update surveycontact by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSurveyContactAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyContactAsync$Plain(params: UpdateSurveyContactAsync$Plain$Params, context?: HttpContext): Observable<ClientSurveyContactModel> {
    return this.updateSurveyContactAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyContactModel>): ClientSurveyContactModel => r.body)
    );
  }

  /**
   * update surveycontact by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSurveyContactAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyContactAsync$Json$Response(params: UpdateSurveyContactAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactModel>> {
    return updateSurveyContactAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * update surveycontact by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSurveyContactAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyContactAsync$Json(params: UpdateSurveyContactAsync$Json$Params, context?: HttpContext): Observable<ClientSurveyContactModel> {
    return this.updateSurveyContactAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyContactModel>): ClientSurveyContactModel => r.body)
    );
  }

}
